import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function FinanceRouteFallback() {
  return (
    <Box minHeight="50vh" display="flex" alignItems="center" justifyContent="center">
      <CircularProgress />
    </Box>
  );
}
